export const LabelTypeEnumValues = [
    'SALESFUNNEL',
    'SALESPROMOTION',
    'CONTACTS',
    'ACCOUNTS',
    'ORDERS',
    'PRODUCT',
    'WEBSITES',
];
export const SalesPromotionReportTypeEnumValues = ['CONTACT', 'ACCOUNT', 'ORDER', 'OFFER'];
export const RoleEnumValues = ['ADVERTISER', 'AGENCY', 'BROKER', 'OTHER', 'PUBLISHER'];
export const GenderEnumValues = ['MALE', 'FEMALE'];
export const OutcomeFilterEnumValues = ['OFFER_NOT_ACCEPTED', 'OFFER_ACCEPTED', 'CONTACTED_CLIENT'];
export const InvoiceStateEnumValues = ['OPEN', 'CHARGED', 'PAID', 'CANCELED', 'NONE', 'SPLIT', 'BAD_DEBT', 'ARCHIVED'];
export const PromotionEmailPlaceholdersEnumValues = ['CONTACT_LAST_NAME', 'CONTACT_FIRST_NAME', 'ACCOUNT_NAME'];
export const TaskStatusEnumValues = ['NEW', 'IN_PROGRESS', 'SNOOZED', 'DONE', 'ARCHIVED'];
export const TaskActivityStatusColorEnumValues = ['GREEN', 'YELLOW', 'RED'];
export const TaskOutcomeEnumValues = [
    'NOT_REACHED',
    'NOT_INTERESTED',
    'OFFER_DENIED',
    'INTERESTED_BUT_NO_OFFER',
    'OFFER_ACCEPTED',
    'SUCCESSFULL_WITHOUT_OFFER',
    'OFFER_NOT_ACCEPTED',
    'DUPLICATE',
    'NO_POTENTIAL',
    'AGED',
    'NOT_PROCESSED',
    'OTHER',
];
export const TaskAdditionalStatusEnumValues = ['NEW', 'RETURNED_FROM_SNOOZED', 'NONE'];
export const TaskPriorityEnumValues = ['HIGH', 'MEDIUM', 'LOW'];
export const PositionLeadReportTypeEnumValues = ['MAIL', 'STORE'];
export const SalesPromotionStatusEnumValues = ['ACTIVE', 'INACTIVE', 'CANCELED_STATUS'];
export const SalesPromotionPhaseEnumValues = ['PLANNED', 'RUNNING', 'FINISHED', 'INACTIVE', 'CANCELED'];
export const LanguageCodeEnumValues = ['DE', 'EN', 'FR', 'IT'];
export {};
